export default "__VITE_ASSET__SrXS4Sh0__"